module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-35.14214f95.svg";